import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './SecondaryNavMobile.module.less';

const SecondaryNavMobileSubMenu = ({ links }) => {
  return (
    links?.length > 0 && (
      <ul className={styles.subMenu__submenu}>
        {links.map((menuLink, index) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <div key={`menu-list-${index}`}>
            {menuLink.category && (
              <p className={classNames(styles.subMenu__text, styles.blackText)}>
                {menuLink.category}
              </p>
            )}
            {menuLink.links.map((submenuLink, mIndex) => (
              <li
                /* eslint-disable-next-line react/no-array-index-key */
                key={`submenu-link-list-${mIndex}`}
                className={styles.subMenu__submenuListItem}
              >
                <a href={submenuLink.path} className={styles.subMenu__text}>
                  {submenuLink.label}
                </a>
              </li>
            ))}
          </div>
        ))}
      </ul>
    )
  );
};

SecondaryNavMobileSubMenu.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      link: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string,
          path: PropTypes.string,
          name: PropTypes.string,
        })
      ),
    })
  ),
};

SecondaryNavMobileSubMenu.defaultProps = {
  links: [],
};
export default SecondaryNavMobileSubMenu;
